export const scrolly = () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          e.preventDefault();

          document.querySelector(this.getAttribute('href')).scrollIntoView({
              behavior: 'smooth', block: 'start'
          });
      });
  });

  if ((window.location.search) === '?awards') {
    document.querySelector('#awards').scrollIntoView({
        behavior: 'smooth', block: 'start'
    });
  }
};
